import { RunbookPeriodicity } from '@/contexts/recurring-tasks/Runbook.interfaces'
import { RunbooksColumnId } from '@/contexts/recurring-tasks/runbooks/runbooks-datatable/RunbooksDatatable.interfaces'

export const RUNBOOKS_ROUTE_NAME = 'runbook'
export const RUNBOOKS_CONTRIBUTION_ROUTE_NAME = 'glrunbook'
export const RUNTASKS_ROUTE_NAME = 'runtask'
export const RUNTASKS_CONTRIBUTION_ROUTE_NAME = 'runtask_contribution'
export const RUNBOOK_LABEL_ROUTE_NAME = 'runtask_label'

export const RUNBOOKS_LIST_DISPLAY_VIEWS = {
  LIST: 'list',
  WORKLOAD: 'workload',
  LABELS: 'labels',
}
export const RUNBOOK_DISPLAY_VIEWS = {
  GANTT: 'gantt',
  WORKLOAD: 'workload',
  PROOF_ENTRY: 'proof_entry',
  LIST: 'list',
}

export const RUNBOOK_AGGREGATE_ID = 'all'

export const RUNBOOKS_CONTRIBUTION_HIDDEN_COLUMN_IDS: RunbooksColumnId[] = [
  RunbooksColumnId.RUNTASK_GROUPS,
  RunbooksColumnId.STATUS_365,
  RunbooksColumnId.STATUS_PERIOD,
  RunbooksColumnId.ACTIONS,
]

export const RUNBOOKS_LIST_DISPLAY_TYPES: string[] = Object.values(RUNBOOKS_LIST_DISPLAY_VIEWS)

export const RUNBOOK_EDIT_MODAL_ID = 'runbook_edit'

export const RUNBOOK_METRICS_ENTRY_MODAL_ID = 'runbooks_metrics_entry'

export const RUNBOOK_EDIT_PANEL_CLOSE_TRANSITION_MS = 500

export const RUNBOOK_ALL_REGISTERS_OPTION_ID = 0

export const HAVE_TO_COMPLETE_QUERY_PARAM = 'have_to_complete'

export const RUNBOOK_STATUS_TO_TREAT_INDEX = 2

export const RUNBOOK_REPORT_TEXT_SIZES: number[] = [10, 11, 12]

export const RUNBOOK_PERIODICITY_ORDER: RunbookPeriodicity[] = [
  RunbookPeriodicity.HOURLY,
  RunbookPeriodicity.DAILY,
  RunbookPeriodicity.WEEKLY,
  RunbookPeriodicity.MONTHLY,
  RunbookPeriodicity.QUARTERLY,
  RunbookPeriodicity.SEMESTERLY,
  RunbookPeriodicity.YEARLY,
]

export const RUNBOOK_FILTERABLE_PERIODICITIES: RunbookPeriodicity[] = [
  RunbookPeriodicity.DAILY,
  RunbookPeriodicity.WEEKLY,
  RunbookPeriodicity.MONTHLY,
  RunbookPeriodicity.QUARTERLY,
  RunbookPeriodicity.SEMESTERLY,
  RunbookPeriodicity.YEARLY,
]

export const RUNBOOK_FILTER_IDS = {
  PERIODICITY: 'periodicity',
  MEASURE: 'measure',
  LABEL: 'label',
  MANAGER: 'manager',
  MISSING_ENTRIES: 'missing_entries',
}

export const RUNBOOK_UNASSIGNED_MANAGER_ID = 'UNASSIGNED'

export const RUNBOOK_MISSING_ENTRIES_IDS = {
  YES: 'YES',
  NO: 'NO',
}

export const RUNBOOK_TASKS_PER_PAGE = 20
